'use strict';
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar from "./com.raquo.airstream.state.-Lazy-Derived-Var.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits from "./com.raquo.laminar.api.-Implicits.js";
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dSeq$0024collection$002dSeq$002dRenderable$0024 from "./com.raquo.laminar.modifiers.-Renderable-Seq$collection-Seq-Renderable$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm from "./dev.cheleb.scalamigen.-Form.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_package$package$$anon$4(elements$3, labelMapper$3) {
  this.rU = null;
  this.vd = null;
  this.HR = null;
  this.rU = elements$3;
  this.vd = labelMapper$3;
  $j_dev$002echeleb$002escalamigen$002e$002dForm.$f_Ldev_cheleb_scalamigen_Form__$init$__V(this);
}
export { $c_Ldev_cheleb_scalamigen_package$package$$anon$4 as $c_Ldev_cheleb_scalamigen_package$package$$anon$4 };
$p = $c_Ldev_cheleb_scalamigen_package$package$$anon$4.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_package$package$$anon$4;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_package$package$$anon$4() {
}
export { $h_Ldev_cheleb_scalamigen_package$package$$anon$4 as $h_Ldev_cheleb_scalamigen_package$package$$anon$4 };
$h_Ldev_cheleb_scalamigen_package$package$$anon$4.prototype = $p;
$p.dJ = (function() {
  return this.HR;
});
$p.dt = (function(x$1) {
  this.HR = x$1;
});
$p.du = (function(x$1) {
});
$p.dx = (function(label, required, factory) {
  return factory.cX(required, label);
});
$p.bt = (function(path, variable, factory, errorBus) {
  var xs = this.rU;
  var f = this.vd;
  var ct__runtimeClass;
  var ct__runtimeClass = $j_java$002elang$002e$002dObject.$d_T.l();
  var len = $j_java$002elang$002e$002dObject.$m_jl_reflect_Array$().aB(xs);
  var componentType = ct__runtimeClass;
  var ys = componentType.J.U(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_O)) {
      while ((i < len)) {
        $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys, i, f.j(xs.a[i]));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
      while ((i < len)) {
        $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys, i, f.j(xs.a[i]));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
      while ((i < len)) {
        $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys, i, f.j(xs.a[i]));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
      while ((i < len)) {
        var $x_5 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_4 = i;
        var $x_2 = xs.a;
        var $x_3 = (i << 1);
        var $x_1_$_lo = $x_2[$x_3];
        var $x_1_$_hi = $x_2[(($x_3 + 1) | 0)];
        $x_5.F(ys, $x_4, f.j($j_java$002elang$002e$002dObject.$bL($x_1_$_lo, $x_1_$_hi)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
      while ((i < len)) {
        $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys, i, f.j(xs.a[i]));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
      while ((i < len)) {
        $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys, i, f.j($j_java$002elang$002e$002dObject.$bC(xs.a[i])));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
      while ((i < len)) {
        $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys, i, f.j(xs.a[i]));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
      while ((i < len)) {
        $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys, i, f.j(xs.a[i]));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
      while ((i < len)) {
        $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys, i, f.j(xs.a[i]));
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(xs);
    }
  }
  var $x_15 = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.U();
  var $x_14 = factory.uw($j_java$002elang$002e$002dObject.$m_sc_ArrayOps$().Ph(this.rU, variable.a4().b3().C(), 0), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var idx = (v1$2 | 0);
    $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__set__O__V(variable, $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aQ(this.rU, idx));
  })));
  var $x_13 = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d;
  var ct$1__runtimeClass;
  var ct$1__runtimeClass = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$d_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.l();
  var len$1 = ys.a.length;
  var componentType$1 = ct$1__runtimeClass;
  var ys$1 = componentType$1.J.U(len$1);
  if ((len$1 > 0)) {
    var i$1 = 0;
    while ((i$1 < len$1)) {
      var $x_12 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
      var $x_11 = i$1;
      var x0 = ys.a[i$1];
      var xs$2 = this.rU;
      var f$1 = this.vd;
      var ct$2__runtimeClass;
      var ct$2__runtimeClass = $j_java$002elang$002e$002dObject.$d_T.l();
      var len$2 = $j_java$002elang$002e$002dObject.$m_jl_reflect_Array$().aB(xs$2);
      var componentType$2 = ct$2__runtimeClass;
      var ys$2 = componentType$2.J.U(len$2);
      if ((len$2 > 0)) {
        var i$2 = 0;
        if ((xs$2 instanceof $j_java$002elang$002e$002dObject.$ac_O)) {
          while ((i$2 < len$2)) {
            $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys$2, i$2, f$1.j(xs$2.a[i$2]));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((xs$2 instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
          while ((i$2 < len$2)) {
            $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys$2, i$2, f$1.j(xs$2.a[i$2]));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((xs$2 instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
          while ((i$2 < len$2)) {
            $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys$2, i$2, f$1.j(xs$2.a[i$2]));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((xs$2 instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
          while ((i$2 < len$2)) {
            var $x_10 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
            var $x_9 = i$2;
            var $x_7 = xs$2.a;
            var $x_8 = (i$2 << 1);
            var $x_6_$_lo = $x_7[$x_8];
            var $x_6_$_hi = $x_7[(($x_8 + 1) | 0)];
            $x_10.F(ys$2, $x_9, f$1.j($j_java$002elang$002e$002dObject.$bL($x_6_$_lo, $x_6_$_hi)));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((xs$2 instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
          while ((i$2 < len$2)) {
            $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys$2, i$2, f$1.j(xs$2.a[i$2]));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((xs$2 instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
          while ((i$2 < len$2)) {
            $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys$2, i$2, f$1.j($j_java$002elang$002e$002dObject.$bC(xs$2.a[i$2])));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((xs$2 instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
          while ((i$2 < len$2)) {
            $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys$2, i$2, f$1.j(xs$2.a[i$2]));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((xs$2 instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
          while ((i$2 < len$2)) {
            $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys$2, i$2, f$1.j(xs$2.a[i$2]));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((xs$2 instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
          while ((i$2 < len$2)) {
            $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().F(ys$2, i$2, f$1.j(xs$2.a[i$2]));
            i$2 = ((1 + i$2) | 0);
          }
        } else {
          throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(xs$2);
        }
      }
      $x_12.F(ys$1, $x_11, factory.uv(x0, $j_java$002elang$002e$002dObject.$m_sc_ArrayOps$().Ph(ys$2, x0, 0), (x0 === this.vd.j(variable.a4().b3().C()))));
      i$1 = ((1 + i$1) | 0);
    }
  }
  return $x_15.u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($x_14, $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits.$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($x_13, $j_java$002elang$002e$002dObject.$m_sc_ArrayOps$().Y7(ys$1), $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dSeq$0024collection$002dSeq$002dRenderable$0024.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]))]));
});
var $d_Ldev_cheleb_scalamigen_package$package$$anon$4 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_package$package$$anon$4, "dev.cheleb.scalamigen.package$package$$anon$4", ({
  jq: 1,
  a2: 1
}));
export { $d_Ldev_cheleb_scalamigen_package$package$$anon$4 as $d_Ldev_cheleb_scalamigen_package$package$$anon$4 };
